import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto as toFacebookPageDto } from '../../../../models/adapters/FacebookPageAdapter';
import { facebookPageSaved, facebookPageSaveFailed, saveFacebookPage, SaveFacebookPageActionType } from '../../../actions/setting/facebook/saveFacebookPage';
import getAuthenticationToken from '../../getAuthenticationToken';
import getProtectedResponse from '../../getProtectedResponse';

function* saveFacebookPageSaga({ payload }: SaveFacebookPageActionType) {
  const { facebookPage, placeUuid } = payload;
  const token = yield getAuthenticationToken();
  const facebookPageDto = toFacebookPageDto(facebookPage, placeUuid);
  const timestamp = moment();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.saveFacebookPage, token, {
    facebookPage: facebookPageDto,
  });

  if (!response.error) {
    yield put(facebookPageSaved({ facebookPage, placeUuid, timestamp }));
  } else {
    yield put(facebookPageSaveFailed({ facebookPage, placeUuid, timestamp }));
  }
}

export default function* watchSaveFacebookPageSaga() {
  yield takeEvery(saveFacebookPage, saveFacebookPageSaga);
}
